import moduleRegistry from '../module-registry/module-registry';

const config = {
    selectors: {
        root: '.legal-overlay',
        checkbox: '.legal-overlay__checkbox',
        openBox: '.legal-overlay--open'
    },
    ids: {
        submit: 'cookie-confirm-btn',
        cancle: 'cookie-cancel-btn'
    },
    class: {
        rootOpen: 'legal-overlay--open'
    }
   
};

class LegalOverlay {
    constructor($rootElement) {
        this._$rootElement = $rootElement;
    }

    init() {
        this._elements = this._getDomElements();
        this._addEventListeners();
       
        $(config.selectors.root).addClass('legal-overlay--open')
        if($(config.selectors.root).hasClass('legal-overlay--open')) {
            $('body').addClass('body--no-scroll')
        }
    }

    _getDomElements() {
        return {
            $root: this._$rootElement.find(config.selectors.root),
            $submit: document.getElementById(config.ids.submit),
            $cancle: document.getElementById(config.ids.cancle),
            $checkbox: this._$rootElement.find(config.selectors.checkbox),
            $openBox: this._$rootElement.find(config.selectors.openBox)
        };
    }

    _addEventListeners() {
     $(this._elements.$submit).on('click', (event) => {
        event.stopPropagation();
        if(!$(this._elements.$checkbox).checked) {
            $(this._elements.$checkbox).addClass('required')
        }else {
            $(this._elements.$checkbox).removeClass('required')
            $('body').removeClass('body--no-scroll')
        }
     })

     $(this._elements.$cancle).on('click', (event) => {
        event.stopPropagation();
        $('body').removeClass('body--no-scroll')
     })


     $(this._elements.$checkbox).on('click', (event) => {
       
        if($(this._elements.$checkbox)) {
            $(this._elements.$checkbox).removeClass('required')
        }
     
     })
    }

   
}

moduleRegistry.registerModule('LegalOverlay', LegalOverlay);
moduleRegistry.autoApplyModule('LegalOverlay', config.selectors.root);